export const COL_PROPS = {
  col: "col",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
  xxl: "xxl",
  offset: "offset",
  order: "order",
} as const;

export const VALID_ALIGN_VALUES = ["start", "center", "end", "baseline", "stretch"] as const;

export const VALID_COL_VALUES = ["auto", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"] as const;

export const VALID_CONTAINER_VALUES = [
  "container",
  "container-fluid",
  "container-sm",
  "container-md",
  "container-lg",
  "container-xl",
  "container-xxl",
] as const;

export const VALID_DISPLAY_VALUES = ["block", "inline", "flex"] as const;

export const VALID_FLEX_DIRECTION_VALUES = ["row", "row-reverse", "column", "column-reverse"] as const;

export const VALID_GAP_VALUES = ["0", "sm", "md", "lg"] as const;

export const VALID_GUTTER_VALUES = ["0", "sm", "md", "lg"] as const;

export const VALID_JUSTIFY_VALUES = ["start", "center", "end", "between", "around", "evenly"] as const;

export const VALID_MARGIN_VALUES = ["0", "sm", "md", "lg"] as const;

export const VALID_PADDING_VALUES = ["0", "sm", "md", "lg"] as const;

export const RESPONSIVE_SPACING_VALUES = {
  "0": ["0"],
  sm: ["4"],
  md: ["4", "md-5", "lg-5", "xl-5", "xxl-5"],
  lg: ["4", "md-5", "lg-6", "xl-6", "xxl-6"],
} as const;

export type AlignType = (typeof VALID_ALIGN_VALUES)[number];
export type ColPropsType = (typeof VALID_COL_VALUES)[number] | null;
export type ContainerType = (typeof VALID_CONTAINER_VALUES)[number];
export type DisplayType = (typeof VALID_DISPLAY_VALUES)[number];
export type FlexDirectionType = (typeof VALID_FLEX_DIRECTION_VALUES)[number];
export type GapType = (typeof VALID_GAP_VALUES)[number];
export type GutterType = (typeof VALID_GUTTER_VALUES)[number];
export type JustifyType = (typeof VALID_JUSTIFY_VALUES)[number];
export type MarginType = (typeof VALID_MARGIN_VALUES)[number];
export type PaddingType = (typeof VALID_PADDING_VALUES)[number];

export const validateColProps = (value: string | number | null): value is ColPropsType => {
  return value === null || VALID_COL_VALUES.includes(value as (typeof VALID_COL_VALUES)[number]);
};
